export default "__VITE_ASSET__Cl_14r3y__"